import { connect } from 'react-redux';
import storage from 'app/services/storage';
import eventsModule from 'app/store/events';
import layoutModule from 'app/store/layout';
import AllEvents from './AllEvents.component';

const { clearErrorApi } = layoutModule.actions;

const { requestAllEvents, resetAllEvents, setDate } = eventsModule.actions;

const mapDispatchToProps = {
  getAllEvents: requestAllEvents,
  resetState: resetAllEvents,
  setStoreDate: setDate,
  clearErrorApi
};

const mapStateToProps = ({ events, user, layout }) => ({
  events: events.allEvents,
  dates: events.monthsList,
  storeDate: events.date,
  locations: layout.locations,
  isLoggedIn: !!user.user,

  savedLocation: storage.getLocation(),
  saveLocation: location => {
    storage.setLocation(location);
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllEvents);
